import { SectionGroupDetail } from "@/modules/ServiceTemplate/models/SectionGroupDetail";
import { ServiceTemplateModel } from "@/modules/ServiceTemplate/models/ServiceTemplateModel";
import { ServiceTemplateService } from "@/modules/ServiceTemplate/services/ServiceTemplateService";
import { TEMPLATE_PDF_ACCESS } from "@/modules/TemplatePdf/constants/TemplatePdfConstants";
import { PdfTemplateSection } from "@/modules/TemplatePdf/Models/sectionsPdf";
import { TemplatePdf } from "@/modules/TemplatePdf/Models/templatePdf";
import { TemplatePdfService } from "@/modules/TemplatePdf/services/templatePdfService";
import { List } from "@/shared/components/GenericSearchBar/model/List";
import { InputChipField } from "@/shared/components/InputChipString/models/InputChipData";
import ModalTemplate from "@/shared/components/ModalTemplate/ModalTemplate.vue";
import Snackbar from "@/shared/components/Snackbar/Snackbar";
import {
  FORM_CONSTANTS,
  FORM_MESSAGES,
  FORM_VALIDATORS
} from "@/shared/constants/FormConstants";
import { STYLE_CLASSES } from "@/shared/constants/StyleConstants";
import { Http } from "@status/codes";
import { AxiosError } from "axios";
import { Component, Inject, Prop, Vue, Watch } from "vue-property-decorator";
import {
  ActionPlan,
  ConfigActionPlan,
  ConfigInputs,
  InfoInput,
  ListaSelect,
  ListSelectDetails,
  SourceInfoArray,
  SourceInfoDetails
} from "../../models/ActionPlan.model";
import { Utils } from "./../../../../shared/utils/utils";
import {
  ACTION_PLAN_ACCESS,
  ACTION_PLAN_CONSTANTS
} from "./../../constants/ActionPlanConstants";
import { SourceInfo } from "./../../models/ActionPlan.model";
import { ActionPlanService } from "./../../services/ActionPlanService";
import CreateData from "./../CreateData/CreateData.vue";
import HeaderActionPlan from "./../HeaderActionPlan/HeaderActionPlan.vue";
import OutData from "./../OutData/OutData.vue";
import PreviewActionPlan from "./../PreviewActionPlan/PreviewActionPlan.vue";
import SourceData from "./../SourceData/SourceData.vue";
import VariableActionPlan from "./../VariableActionPlan/VariableActionPlan.vue";

@Component({
  name: "SaveActionPlan",
  components: {
    ModalTemplate,
    HeaderActionPlan,
    SourceData,
    OutData,
    CreateData,
    PreviewActionPlan,
    VariableActionPlan
  }
})
export default class SaveActionPlan extends Vue {
  @Inject() actionPlanService!: ActionPlanService;
  @Inject() templatePdfService!: TemplatePdfService;
  @Inject() serviceTemplateService!: ServiceTemplateService;

  @Prop() idActionPlan!: string;
  @Prop() categories!: List[];
  @Prop({ default: false, required: false })
  public isModal!: boolean;
  @Prop() listDataArray!: SourceInfoArray;
  @Prop() listData!: SourceInfo;
  @Prop() pdfList!: ListaSelect[];
  @Prop() loadingService!: boolean;
  @Prop() loadingGroups!: boolean;
  @Prop() loadingPdfList!: boolean;

  iconBtnClass = STYLE_CLASSES.ICON_BTN;
  SAVE_BTN = FORM_CONSTANTS.BUTTON.SAVE;
  CANCEL = FORM_CONSTANTS.BUTTON.CANCEL;
  PAGE_START = FORM_CONSTANTS.BUTTON.PAGE_START;
  cardClass = STYLE_CLASSES.CARD_2;
  card2Class = STYLE_CLASSES.CARD_PADING;
  TAB = ACTION_PLAN_CONSTANTS.TAB;
  TITLES = ACTION_PLAN_CONSTANTS.TITLES;
  selectedTab = 0;

  sourceInfoDetails: SourceInfoDetails = {
    listInputs: [],
    sections: []
  };

  actionPlanRef = "";

  dialog = false;
  modalTitle = "";
  modalText = "";
  objActionPlan: ActionPlan = {
    state: true,
    category: "",
    name: "",
    sourceInfo: {
      formTemplate: [],
      infoGroup: [],
      serviceTemplate: [],
      variables: []
    },
    outPdf: [],
    config: null,
    htmlText: ""
  };
  configRef: ConfigActionPlan | null = null;

  rules = {
    name: [FORM_VALIDATORS.REQUIRED_FIELD, FORM_VALIDATORS.NOT_BLANK_SPACES]
  };
  isValidName = false;

  invalidEdit = false;
  loadingData = false;

  goToStart(id: string) {
    Utils.scrollToElement(id, this);
  }

  goToInit() {
    this.goToStart(ACTION_PLAN_CONSTANTS.ID_REF_GO_TO);
  }

  async mounted() {
    this.invalidEdit = false;
    if (!this.isModal) {
      this.goToInit();
    }
    if (this.$route.params.id || this.idActionPlan) {
      this.actionPlanRef = this.$route.params.id || this.idActionPlan;
      await this.getActionPlanData(this.actionPlanRef);
      this.loadingData = false;
    }
  }
  get isEditing(): boolean {
    return !!this.actionPlanRef;
  }

  fetchPdfList(name?: string) {
    this.$emit(ACTION_PLAN_CONSTANTS.EMITTERS.FETCH_PDF_LIST, name);
  }

  @Watch("idActionPlan")
  async changeIdActionPlan() {
    this.actionPlanRef = this.idActionPlan;
    await this.getActionPlanData(this.actionPlanRef);
    this.loadingData = false;
  }

  @Watch("objActionPlan.outPdf")
  async changePdfArraySelect() {
    if (!this.loadingData && this.isEditing) {
      this.invalidEdit = false;
    }
    if (this.objActionPlan.config) {
      this.configRef = this.objActionPlan.config;
    }
    this.objActionPlan.config = null;
    if (
      !this.objActionPlan.outPdf ||
      this.objActionPlan.outPdf.length == 0 ||
      !this.objActionPlan.outPdf[0]
    ) {
      return;
    }
    await this.getPdfByID(this.objActionPlan.outPdf[0].key);
  }

  @Watch("objActionPlan.sourceInfo.serviceTemplate")
  emitSelectedTemplate() {
    if (!this.loadingData && this.isEditing) {
      this.invalidEdit = false;
    }
    const selectedTemplate = this.objActionPlan.sourceInfo.serviceTemplate;
    this.$emit(
      ACTION_PLAN_CONSTANTS.EMITTERS.TEMPLATE_SELECTED,
      selectedTemplate
    );
  }

  @Watch("objActionPlan.sourceInfo.formTemplate")
  @Watch("objActionPlan.sourceInfo.infoGroup")
  @Watch("objActionPlan.sourceInfo.serviceTemplate")
  @Watch("objActionPlan.sourceInfo.variables")
  async changeFormTemplateArraySelect() {
    if (!this.loadingData && this.isEditing) {
      this.invalidEdit = false;
    }
    const service = await this.getService();

    this.sourceInfoDetails.sections = service.sections;

    const formTemplateService = service.formTemplateService;
    const infoGroup = this.getInfoGroupArraySelect();
    const formTemplate = this.getFormTemplateArraySelect();
    const listInputs = [];

    for (const formTemplateServiceRef of [
      ...formTemplateService,
      ...formTemplate
    ]) {
      const existInList = listInputs.findIndex(
        inputElement =>
          inputElement.key == formTemplateServiceRef.key &&
          inputElement.type == formTemplateServiceRef.type
      );
      if (existInList >= 0) {
        continue;
      }
      const newFormTemplate = this.listDataArray.formTemplate.find(
        formTemplateRef => formTemplateRef.key == formTemplateServiceRef.key
      );
      if (newFormTemplate) {
        newFormTemplate.sections = formTemplateServiceRef.sections;
        listInputs.push(newFormTemplate);
        continue;
      }

      listInputs.push(formTemplateServiceRef);
    }

    for (const infoGroupRef of infoGroup) {
      const existInList = listInputs.findIndex(
        inputElement =>
          inputElement.key == infoGroupRef.key &&
          inputElement.type == infoGroupRef.type
      );
      if (existInList >= 0) {
        continue;
      }
      const newInfoGroup = this.listDataArray.infoGroup.find(
        infoGroupRefArray => infoGroupRefArray.key == infoGroupRef.key
      );
      if (newInfoGroup) {
        newInfoGroup.sections = infoGroupRef.sections;
        listInputs.push(newInfoGroup);
        continue;
      }

      listInputs.push(infoGroupRef);
    }

    if (this.objActionPlan.sourceInfo.variables?.length >= 1) {
      const formVariables: ListSelectDetails = {
        key: "0",
        name: "variables",
        type: "variable",
        fields: []
      };

      this.objActionPlan.sourceInfo.variables.forEach(variable => {
        const newVar: InputChipField = {
          key: variable.inputName,
          title: variable.inputName,
          type: "var"
        };
        formVariables.fields?.push(newVar);
      });

      listInputs.push(formVariables);
    }
    this.sourceInfoDetails.listInputs = listInputs;
  }

  getFormTemplateArraySelect() {
    let formTemplateArraySelect = [] as ListSelectDetails[];
    if (this.objActionPlan.sourceInfo.formTemplate?.length == 0) {
      return formTemplateArraySelect;
    }
    formTemplateArraySelect = this.listDataArray.formTemplate.filter(
      form =>
        this.objActionPlan.sourceInfo.formTemplate.findIndex(
          formTemplate => formTemplate.key == form.key
        ) >= 0
    );
    return formTemplateArraySelect;
  }

  getInfoGroupArraySelect() {
    let infoGroupArraySelect = [] as ListSelectDetails[];
    if (this.objActionPlan.sourceInfo.infoGroup?.length == 0) {
      return infoGroupArraySelect;
    }
    infoGroupArraySelect = this.listDataArray.infoGroup.filter(
      infoGroupRef =>
        this.objActionPlan.sourceInfo.infoGroup.findIndex(
          (infoGroup: ListSelectDetails) => infoGroup.id == infoGroupRef.key
        ) >= 0
    );
    return infoGroupArraySelect;
  }

  async getServiceById(id: string): Promise<ServiceTemplateModel | void> {
    const responseData = await this.serviceTemplateService.getServiceTemplateById(
      id
    );

    if (responseData.code !== Http.Found || !responseData.data) {
      return;
    }
    return responseData.data;
  }
  async getService() {
    const sections = [] as ListSelectDetails[];
    const formTemplateService = [] as ListSelectDetails[];
    if (
      this.objActionPlan.sourceInfo.serviceTemplate?.length == 0 ||
      !this.objActionPlan.sourceInfo.serviceTemplate[0].key
    ) {
      return { sections, formTemplateService };
    }
    const service = await this.getServiceById(
      this.objActionPlan.sourceInfo.serviceTemplate[0].key
    );
    if (!service) {
      return { sections, formTemplateService };
    }

    service.sections?.forEach(section => {
      sections.push({ name: section.name, key: section.key });
      (section.formTemplates as SectionGroupDetail[])?.forEach(formTemplate => {
        let newFormTempalte = formTemplateService.find(
          form => form.key == formTemplate.id
        );
        if (!newFormTempalte) {
          newFormTempalte = {
            type: "formTemplate",
            name: formTemplate.name,
            key: formTemplate.id,
            sections: [section.key]
          };

          formTemplateService.push(newFormTempalte);
        } else {
          newFormTempalte.sections?.push(section.key);
        }
      });
    });

    return { sections, formTemplateService };
  }

  contructConfig(pdfSelect: TemplatePdf) {
    this.selectedTab = 0;
    const configTemp: ConfigActionPlan = {
      header: {
        title: ACTION_PLAN_CONSTANTS.TITLES.CONFIG_HEADER,
        groupInputs: [
          {
            inputs: [
              {
                type: "boolean",
                inputName: "Fecha de creación",
                formula: []
              }
            ]
          },
          {
            inputs: [
              {
                type: "boolean",
                inputName: "Centro Medico",
                formula: []
              }
            ]
          },
          {
            inputs: [
              {
                type: "boolean",
                inputName: "Atendido por",
                formula: []
              }
            ]
          }
        ]
      },
      sections: []
    };
    let rowHeader = 0;
    pdfSelect?.headerExtraInfo?.forEach(labeld => {
      const inputHeader: InfoInput = {
        inputName: labeld.title,
        formula: []
      };
      if (!configTemp.header.groupInputs[rowHeader]) {
        configTemp.header.groupInputs[rowHeader] = { inputs: [] };
      }
      configTemp.header.groupInputs[rowHeader].inputs.push(inputHeader);
      if (configTemp.header.groupInputs[rowHeader].inputs.length == 2) {
        rowHeader++;
      }
    });

    pdfSelect?.sections?.forEach(section => {
      const sectionNew: ConfigInputs = {
        title: section.title,
        groupInputs: []
      };
      section.labels.forEach(labeld => {
        if (!labeld.title) {
          return;
        }
        const inputSection: InfoInput = {
          inputName: labeld.title,
          formula: []
        };
        if (!sectionNew.groupInputs[0]) {
          sectionNew.groupInputs[0] = { typeRow: "labels", inputs: [] };
        }
        sectionNew.groupInputs[0].inputs.push(inputSection);
      });

      sectionNew.groupInputs.push({
        typeRow: "sintomas",
        inputs: [{ inputName: "Sintomas", formula: [] }]
      });
      sectionNew.groupInputs.push({
        typeRow: "tabla",
        inputs: [
          { inputName: "Medicamentos", formula: [] },
          { inputName: "Via Administracion", formula: [] },
          { inputName: "Dosis", formula: [] },
          { inputName: "Cada", formula: [] }
        ]
      });
      sectionNew.groupInputs.push({
        typeRow: "recomendaciones",
        inputs: [{ inputName: "Recomendaciones", formula: [] }]
      });
      configTemp.sections.push(sectionNew);
    });

    if (this.configRef != null) {
      const valores = this.configRef?.header.groupInputs.flatMap(
        input => input.inputs
      );
      if (valores.length == 0) {
        return;
      }
      configTemp.header.groupInputs.forEach(grupoInputs => {
        for (const header of grupoInputs.inputs) {
          const ref = valores.find(
            input => input.inputName == header.inputName
          );
          if (!ref) {
            continue;
          }
          header.formula = ref.formula;
          if (ref.value) {
            header.value = ref.value;
          }
        }
      });

      configTemp.sections.forEach(section => {
        const sectionSelect = this.configRef?.sections.find(
          sectionref => sectionref.title == section.title
        );

        section.sectionService = sectionSelect?.sectionService;
        const valores = sectionSelect?.groupInputs.flatMap(
          input => input.inputs
        );

        if (!valores || valores.length == 0) {
          return;
        }

        section.groupInputs.forEach(groupInputSelect => {
          groupInputSelect.inputs.forEach(inputSelect => {
            const ref = valores.find(
              input => input.inputName == inputSelect.inputName
            );

            if (!ref) {
              return;
            }
            inputSelect.formula = ref.formula;
          });
        });
      });
    }
    this.objActionPlan.config = configTemp;
  }

  async getActionPlanData(id: string) {
    try {
      const response = await this.actionPlanService.getActionPlanById(id);
      if (response.code !== Http.Found || !response.data) {
        throw new Error(FORM_MESSAGES.REQUEST_FAILED);
      }
      this.invalidEdit = true;
      this.loadingData = true;

      this.configRef = response.data.config;
      this.objActionPlan = response.data;
      this.isValidName = this.objActionPlan.name != "" ? true : false;
    } catch (error) {
      if ((error as AxiosError).response?.status == Http.Forbidden)
        Snackbar.popError(
          FORM_MESSAGES.FORBIDDEN_REQUEST + ACTION_PLAN_ACCESS.GET
        );
      else Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
    }
  }
  pdfSections: PdfTemplateSection[] = [];

  async getPdfByID(id: string) {
    try {
      const response = await this.templatePdfService.getTemplateById(id);
      if (response.code !== Http.Found || !response.data) {
        throw new Error(FORM_MESSAGES.REQUEST_FAILED);
      }
      this.pdfSections = response.data.sections ?? [];
      this.contructConfig(response.data);
    } catch (error) {
      if ((error as AxiosError).response?.status == Http.Forbidden)
        Snackbar.popError(
          FORM_MESSAGES.FORBIDDEN_REQUEST + TEMPLATE_PDF_ACCESS.PUT
        );
      else Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
    }
  }
  validateData() {
    const configInputs: ConfigInputs[] = [];
    if (this.objActionPlan.config) {
      configInputs.push(this.objActionPlan.config.header);
      configInputs.push(...this.objActionPlan.config.sections);
    }

    for (const configInput of configInputs) {
      for (const groupInput of configInput.groupInputs) {
        for (const input of groupInput.inputs) {
          if (input.formula.length == 0 && input.type != "boolean") {
            return (
              "Falta '" + input.inputName + "' de '" + configInput.title + "'"
            );
          }
        }
      }
    }
    return "";
  }
  async save() {
    const actionPlan = await this.convertData();
    try {
      const result = await this.actionPlanService.addActionPlan(actionPlan);

      if (result.code === Http.Found) {
        Snackbar.popInfo(ACTION_PLAN_CONSTANTS.MESSAGES.ALREADY_EXIST);
        return;
      }
      if (result.code !== Http.Ok) {
        throw new Error(FORM_MESSAGES.REQUEST_FAILED);
      }

      Snackbar.popSuccess(ACTION_PLAN_CONSTANTS.MESSAGES.CREATED);
      this.onClose();
    } catch (error) {
      if ((error as AxiosError).response?.status == Http.Forbidden)
        Snackbar.popError(
          FORM_MESSAGES.FORBIDDEN_REQUEST + ACTION_PLAN_ACCESS.POST
        );
      else Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
    }
  }

  async update() {
    const actionPlan = await this.convertData();

    try {
      const result = await this.actionPlanService.updateActionPlanById(
        this.actionPlanRef,
        actionPlan
      );

      if (result.code !== Http.Ok) {
        throw new Error(FORM_MESSAGES.REQUEST_FAILED);
      }
      Snackbar.popSuccess(ACTION_PLAN_CONSTANTS.MESSAGES.UPDATED);
      this.onClose();
    } catch (error) {
      if ((error as AxiosError).response?.status == Http.Forbidden)
        Snackbar.popError(
          FORM_MESSAGES.FORBIDDEN_REQUEST + ACTION_PLAN_ACCESS.PUT
        );
      else Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
    }
  }

  checkSave() {
    const validation = this.validateData();
    if (validation) {
      Snackbar.popError(validation);
      return;
    }
    if (this.actionPlanRef) {
      this.modalTitle = FORM_MESSAGES.UPDATE_MODAL.TITLE;
      this.modalText = FORM_MESSAGES.UPDATE_MODAL.TEXT;
    } else {
      this.modalTitle = FORM_MESSAGES.SAVE_MODAL.TITLE;
      this.modalText = FORM_MESSAGES.SAVE_MODAL.MESSAGE;
    }
    this.dialog = true;
  }

  getHtml(): string {
    const element = document.getElementById("previewPlanAction") as HTMLElement;
    const htmlText = element.innerHTML;
    return htmlText;
  }

  async getBase64FromUrl(url: string): Promise<string> {
    const data = await fetch(url);
    const blob = await data.blob();
    return new Promise(resolve => {
      const reader = new FileReader();
      reader.readAsDataURL(blob);
      reader.onloadend = () => {
        const base64data = reader.result as string;
        resolve(base64data);
      };
    });
  }

  async changeImageUrl(htmlText: string) {
    const regular = /src=(".*?")/;
    /* eslint-disable-next-line  @typescript-eslint/no-explicit-any */
    const elementImagen = document.getElementById("imageHeaderLogo") as any;
    const url = elementImagen.src;

    const ref = regular.exec(elementImagen.outerHTML);
    const oldSrc = ref![0];

    const newSrcImage = await this.getBase64FromUrl(url);
    const htmlTextNew = htmlText.replaceAll(oldSrc, `src="${newSrcImage}"`);

    return htmlTextNew;
  }

  get validActiopnPlan() {
    if (
      !this.objActionPlan ||
      !this.objActionPlan.name ||
      !this.objActionPlan.category ||
      !this.objActionPlan.config ||
      !this.objActionPlan.config.header ||
      // this.objActionPlan.config.header.inputs.findIndex(
      //   input => input.formula.trim() == ""
      // ) != -1 ||
      !this.objActionPlan.config.sections ||
      // this.objActionPlan.config.sections.findIndex(
      //   section =>
      //     section.inputs.findIndex(input => input.formula.trim() == "") != -1
      // ) != -1
      !this.isValidName
    ) {
      return false;
    }
    return true;
  }

  get onPreview(): boolean {
    return this.selectedTab == 1;
  }

  async handleModalAccept() {
    this.dialog = false;
    switch (this.modalTitle) {
      case FORM_MESSAGES.UPDATE_MODAL.TITLE:
        await this.update();
        break;
      case FORM_MESSAGES.SAVE_MODAL.TITLE:
        await this.save();
        break;
    }
  }

  handleModalCancel() {
    this.dialog = false;
  }

  async convertData(): Promise<ActionPlan> {
    this.objActionPlan.htmlText = await this.changeImageUrl(this.getHtml());
    return this.objActionPlan;
  }

  onClose() {
    this.$emit(FORM_MESSAGES.EVENT_BUTTON.CLOSE);
  }

  onCloseModal() {
    this.$emit(FORM_MESSAGES.EVENT_BUTTON.CLOSE_MODAL);
  }

  validNameField(value: boolean) {
    this.isValidName = value;
  }

  fetchServiceTemplates(name?: string) {
    this.$emit(FORM_MESSAGES.FETCH_SERVICE_TEMPLATES, name);
  }
  fetchInfoGroups(name?: string) {
    this.$emit(FORM_MESSAGES.FETCH_INFO_GROUPS, name);
  }
}
